// NPM
import React, { useState, useEffect, useRef } from 'react'
import Slider from "react-slick"
import _ from 'lodash'

// Components
import TeamMember from './TeamMember'

const TeamMembers = ({ sections, teamMembers }) => {
  const [viewingBio, setViewingBio] = useState(false)
  const [selectedTeamMemberIndex, setSelectedTeamMemberIndex] = useState(0)
  const sortedTeamMembers = _.sortBy(teamMembers, "order")
  const sliderRef = useRef(null)

  // Set a random TeamMember each page load
  useEffect(() => {
    const startingIndex = _.random(0 + sortedTeamMembers.length - 1)
    sliderRef.current.slickGoTo(startingIndex)
  }, [])

  const teamMembersSection = sections.find(s => s.uuid === "aboutUs_teamMembers")
  const openBioSection = sections.find(s => s.uuid === "aboutUs_teamMembers-openBio")
  const closeBioSection = sections.find(s => s.uuid === "aboutUs_teamMembers-closeBio")

  const settings = {
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    className: "center",
    slidesToShow: 5,
    swipe: false,
    autoplay: true,
    beforeChange: (current, next) => {
      setSelectedTeamMemberIndex(next)
    },
    onSwipe: () => {
      setViewingBio(false)
    },
    responsive: [
      {
        breakpoint: 821,
        settings: {
          slidesToShow: 3,
          swipe: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          swipe: true
        }
      },
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 1,
          swipe: true
        }
      }
    ]
  }

  if(teamMembersSection && teamMembers.length > 0) {
    return (
      <div className="TeamMembers" id="TeamMembers">
        <div className="TeamMembers__top">
          <h4 className="TeamMembers__title small-header">
            { teamMembersSection.title }
          </h4>
          <div className="TeamMembers__carousel-controls">
            <button
              className="TeamMembers__carousel-controls-prev"
              onClick={ () => {
                sliderRef.current.slickPrev()
                setViewingBio(false)
              }}>
                <img src={ require("src/images/icons/carousel-arrow-left.png").default } />
            </button>

            <button
              className="TeamMembers__carousel-controls-next"
              onClick={ () => {
                sliderRef.current.slickNext()
                setViewingBio(false)
              }}>
                <img src={ require("src/images/icons/carousel-arrow-right.png").default } />
            </button>
          </div>
        </div>

        <div className="TeamMembers__carousel">
          <Slider ref={ sliderRef } { ...settings }>
            {
              sortedTeamMembers.map((teamMember, teamMemberIndex) => {
                return (
                  <TeamMember
                    teamMember={ teamMember }
                    key={ `TeamMember-desktop-${ teamMemberIndex }` }
                    openBioText={ _.get(openBioSection, "title", "open bio") }
                    closeBioText={ _.get(closeBioSection, "title", "close bio") }
                    onClick={ () => {
                      if(selectedTeamMemberIndex === 0 && teamMemberIndex === sortedTeamMembers.length - 1) {
                        sliderRef.current.slickPrev()
                      }
                      else if(selectedTeamMemberIndex === sortedTeamMembers.length - 1 && teamMemberIndex === 0) {
                        sliderRef.current.slickNext()
                      }
                      else {
                        sliderRef.current.slickGoTo(teamMemberIndex) 
                      }
                      setViewingBio(true) 
                    }}
                    viewingBio={ viewingBio }
                    setViewingBio={ setViewingBio }
                    selectedTeamMemberIndex={ selectedTeamMemberIndex }
                    teamMemberIndex={ teamMemberIndex }
                  />
                )
              })
            }
          </Slider>
        </div>
      </div>
    )
  }
  else {
    return null;
  }
}

export default TeamMembers;